import cn from 'client/utils/cn';

import React, { ChangeEvent, Component } from 'react';

import { BlogPostItem, BundleData, PostTag } from 'client/bundles/types';
import BlogItem from 'client/components/blog-item';
import Select from 'client/components/lego/select';
import Seo from 'client/components/seo';

import './index.css';

const b = cn('blog');
const bPageTitle = cn('page-title');

interface Props {
    data: BundleData;
}

export default class BlogPage extends Component<Props> {
    onSelectChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        const url = new URL(window.location.href);

        if (event.target.value === 'all') {
            url.searchParams.delete('tag');
        } else {
            url.searchParams.set('tag', event.target.value);
        }

        window.document.location.href = url.href;
    }

    getTags = () => {
        const { tags } = this.props.data.blogData;

        return tags.map((tag: PostTag) => {
            return {
                key: tag.slug,
                value: tag.slug,
                content: tag.displayName
            };
        });
    }

    getItem = (item: BlogPostItem) => {
        return <BlogItem key={item.title} {...item} />;
    }

    render() {
        const { blogBunker, blogItems, tags, selectedTag } = this.props.data.blogData;

        return (
            <>
                <Seo title={blogBunker.title} />

                <div className={b()}>
                    <div className={b('title')}>
                        <h1 className={bPageTitle({ type: 'border' })}>{blogBunker.title}</h1>

                        {
                            tags.length > 0 &&
                            <div className={b('controls')}>
                                <Select
                                    size="m"
                                    theme="normal"
                                    className={b('tags-select')}
                                    value={selectedTag || 'all'}
                                    options={this.getTags()}
                                    onChange={this.onSelectChange}
                                    />
                            </div>
                        }
                    </div>

                    <div className={b('content')}>
                        {/* tslint:disable-next-line:no-any */}
                        {blogItems.map((item: any) => this.getItem(item))}
                    </div>
                </div>
            </>
        );
    }
}
